import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./FriendsIcon.module.scss";
import { v4 } from "uuid";
import ImageLoader from "./ImageLoader";
import { Span } from "../../../Styleds";
const FriendsIcon = ({ users, type = "view",remain_number=0, addModalType,onAdd}) => {
    const [userList, set_userList] = useState([]);
    useEffect(() => {
        set_userList(users);
    }, []);
    return (
        <div className={style.app}>
            <div className={style.peoples}>
                {userList.slice(0, 3).map((v, k) => {
                    return <div key={k}>
                        <ImageLoader variant={"circular"} style={{ width: "2rem", height: "2rem" }} src={v.user_avatar} />
                    </div>
                })}

                {type === "add" &&
                    <>
                        {userList.length > 3 &&
                            <div onClick={e => {
                                addModalType({
                                    cls: "MoreFriendView", arg: {
                                        users:userList
                                    }
                                })
                            }}>
                                <div className={style.more}>
                                    <img src="./assets/ui/dot.png" />
                                </div>
                            </div>
                        }
                        <div>
                            <div className={style.add} onClick={e => {
                                if(onAdd)
                                onAdd();
                                
                            }}>
                                <img src="./assets/ui/add_w.png" />
                            </div>
                        </div>
                    </>
                }
            </div>
            {(type === "view" &&remain_number>0) &&
                <Span size={13} fontWeight={400} color="#6C6C6C" fontFamily="SF Pro">{`+${remain_number}`}</Span>
            }
        </div>
    );
}

export default FriendsIcon;